import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const UsageChart = ({ data, timeRange }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  
  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }
    
    const ctx = chartRef.current.getContext('2d');
    
    let labels, values, unit;
    
    if (timeRange === 'today') {
      labels = data.map(item => item.hour);
      values = data.map(item => item.minutes);
      unit = 'Minutes';
    } else if (timeRange === 'week') {
      labels = data.map(item => item.day);
      values = data.map(item => item.hours);
      unit = 'Hours';
    } else {
      labels = data.map(item => item.week);
      values = data.map(item => item.hours);
      unit = 'Hours';
    }
    
    chartInstance.current = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: `Screen Time (${unit})`,
            data: values,
            backgroundColor: 'rgba(79, 70, 229, 0.2)',
            borderColor: 'rgba(79, 70, 229, 1)',
            borderWidth: 1,
            borderRadius: 4,
            hoverBackgroundColor: 'rgba(79, 70, 229, 0.4)',
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                let label = context.dataset.label || '';
                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  if (timeRange === 'today') {
                    label += context.parsed.y + ' minutes';
                  } else {
                    label += context.parsed.y + ' hours';
                  }
                }
                return label;
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            grid: {
              color: 'rgba(0, 0, 0, 0.05)',
            },
            ticks: {
              callback: function(value) {
                if (timeRange === 'today') {
                  return value + 'm';
                } else {
                  return value + 'h';
                }
              }
            }
          },
          x: {
            grid: {
              display: false,
            },
          },
        },
      },
    });
    
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data, timeRange]);
  
  return (
    <div className="w-full h-full">
      <canvas ref={chartRef}></canvas>
    </div>
  );
};

export default UsageChart; 